import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { rolesQuery } from '@/api/queries'
import { useCompanyCaller } from '@/app/company'
import { NothingForRole } from '@/app/nothing-for-role'
import { RoleEditor } from '@/app/role-editor'
import { companySections } from '@/domain/abilities'
import { errorText } from '@/domain/errors'
import { t } from '@/i18n'
import { InlineBanner } from '@/ui/inline-banner'
import { Page } from '@/ui/page'
import { LoadingBlock } from '@/ui/spinner'

export const Route = createFileRoute('/_app/c/$orgId/roles/$roleId')({
  component: RolePage,
})

function RolePage() {
  const { orgId, roleId } = Route.useParams()
  const { caller } = useCompanyCaller(orgId)
  const allowed = companySections(caller).includes('roles')
  const roles = useQuery({ ...rolesQuery(orgId), enabled: allowed })

  if (!allowed) return <NothingForRole />
  if (roles.isPending) return <LoadingBlock label={t.app.loading} />
  if (roles.isError) {
    return (
      <Page>
        <InlineBanner kind="error" message={errorText(roles.error)} />
      </Page>
    )
  }
  const role = roles.data.find((r) => r.id === roleId)
  if (!role) {
    return (
      <Page>
        <InlineBanner kind="error" message={t.errors.unknownRole} />
      </Page>
    )
  }
  return <RoleEditor key={role.id} orgId={orgId} caller={caller} mode={{ kind: 'existing', role }} />
}
